import { productSlice } from "./store/product.slice";
import {
  productApi,
  useGetProductsQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useLazyGetProductByIdQuery,
  useLazyGetProductsQuery,
  useDeleteProductMutation
} from "./api/product.api";

export const { setProducts } = productSlice.actions;

export {
  productApi,
  productSlice,
  useGetProductsQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useLazyGetProductByIdQuery,
  useLazyGetProductsQuery,
  useDeleteProductMutation
};
